export enum Colors {
    red = '#fc4661',
    lightBlue = '#72cce6',
    background = '#20234a',
    darkBlue = '#1c1f3f',
    grey = '#2a2e54',
    blue = '#2667bb',
    transparent = 'transparent',
    lightGrey = '#777A92'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/colors.enum.ts